var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSatisfied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8,
    cy: 12,
    r: 9,
    fill: "#FFE178"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 11C17.128 11 17.8 10.328 17.8 9.5C17.8 8.672 17.128 8 16.3 8C15.472 8 14.8 8.672 14.8 9.5C14.8 10.328 15.472 11 16.3 11Z",
    fill: "#1A1B43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30002 11C10.128 11 10.8 10.328 10.8 9.5C10.8 8.672 10.128 8 9.30002 8C8.47202 8 7.80002 8.672 7.80002 9.5C7.80002 10.328 8.47202 11 9.30002 11Z",
    fill: "#1A1B43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 17C11.481 17 10.198 16.567 9.18602 15.781C8.75002 15.442 8.67102 14.814 9.01002 14.378C9.34802 13.941 9.97602 13.864 10.413 14.202C11.738 15.231 13.861 15.231 15.186 14.202C15.622 13.864 16.25 13.941 16.589 14.378C16.928 14.815 16.849 15.442 16.413 15.781C15.401 16.567 14.118 17 12.799 17H12.8Z",
    fill: "#1A1B43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.79 2C7.27002 2 2.80002 6.48 2.80002 12C2.80002 17.52 7.27002 22 12.79 22C18.31 22 22.8 17.52 22.8 12C22.8 6.48 18.32 2 12.79 2ZM12.8 20C8.38002 20 4.80002 16.42 4.80002 12C4.80002 7.58 8.38002 4 12.8 4C17.22 4 20.8 7.58 20.8 12C20.8 16.42 17.22 20 12.8 20Z",
    fill: "#1A1B43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSatisfied);
export default __webpack_public_path__ + "static/media/icon-satisfied.4b9087c7c7976fda7c764d251c448779.svg";
export { ForwardRef as ReactComponent };